import { ApolloClient, HttpLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client'
import { ChainId } from '@uniswap/sdk-core'
import { DEFAULT_CHAIN_ID } from 'constants/chains'

const CHAIN_V2_SUBGRAPH_URL: Record<number, string> = {
  [ChainId.WORLD_CHAIN]: 'https://subgraph.worldswap.org/subgraphs/name/v2-worldchain',
}

const CHAIN_BLOCK_SUBGRAPH_URL: Record<number, string> = {
  [ChainId.WORLD_CHAIN]: 'https://subgraph.worldswap.org/subgraphs/name/blocks-worldchain',
}

export function getApolloClientV2ByChain(chainId: number | undefined): ApolloClient<NormalizedCacheObject> | undefined {
  const uri = !!chainId && CHAIN_V2_SUBGRAPH_URL[chainId]
  if (!uri) {
    return undefined
  }
  return new ApolloClient({
    link: new HttpLink({ uri }),
    cache: new InMemoryCache(),
  })
}

export function getBlockClientByChain(chainId: number | undefined): ApolloClient<NormalizedCacheObject> {
  return new ApolloClient({
    uri: (chainId && CHAIN_BLOCK_SUBGRAPH_URL[chainId]) || CHAIN_BLOCK_SUBGRAPH_URL[DEFAULT_CHAIN_ID],
    cache: new InMemoryCache(),
    queryDeduplication: true,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  })
}
